document.addEventListener('DOMContentLoaded', () => {
  const navButton = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');

  if (navButton && nav) {
    navButton.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      navButton.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-scroll]').forEach((element) => {
    element.addEventListener('click', (event) => {
      const id = element.getAttribute('href');
      const target = id && id.startsWith('#') ? document.querySelector(id) : null;
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  document.querySelectorAll('[data-announcement-slider]').forEach((slider) => {
    const messages = Array.from(slider.querySelectorAll('[data-announcement-message]'));
    const previous = slider.querySelector('[data-announcement-prev]');
    const next = slider.querySelector('[data-announcement-next]');
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Math.max(Number(slider.dataset.interval) || 5000, 3000);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;

    if (messages.length < 2) {
      slider.classList.add('has-single-message');
      return;
    }

    const showMessage = (index) => {
      activeIndex = (index + messages.length) % messages.length;
      messages.forEach((message, messageIndex) => {
        const active = messageIndex === activeIndex;
        message.hidden = !active;
        message.classList.toggle('is-active', active);
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && !reducedMotion && !document.hidden) {
        timer = window.setInterval(() => showMessage(activeIndex + 1), interval);
      }
    };

    previous?.addEventListener('click', () => {
      showMessage(activeIndex - 1);
      start();
    });
    next?.addEventListener('click', () => {
      showMessage(activeIndex + 1);
      start();
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', (event) => {
      if (!slider.contains(event.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', start);
    start();
  });
});
